// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.FilesComponent-module__filesBox--Hslzj {
    display: flex;
    flex-direction: column;
    gap: 20px;
    align-items: flex-start;
    margin-top: 20px;
    max-height: 600px;
    overflow-y: auto;
}

.FilesComponent-module__fileItem--EhXXF {
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 5px;
    cursor: pointer;
    padding: 8px;
    color: #0054E6;
    font-size: 14px;
    font-weight: 500;
    text-decoration: none;
    box-shadow: 0px 0px 28px -15px rgba(34, 60, 80, 0.51);
    border-radius: 14px;
    width: 90%;
    justify-content: space-between;
    transition: transform 0.3s ease;
}

.FilesComponent-module__fileItem--EhXXF:hover {
    transform: scale(1.02);
    box-shadow: 0px 5px 30px -10px rgba(34, 60, 80, 0.7);
}

.FilesComponent-module__leftBox--ddfn4 {
    display: flex;
    gap: 16px;
    align-items: center;
}

.FilesComponent-module__fileIcon--VyZgB {
    display: flex;
    align-items: center;
    justify-content: center;

}

.FilesComponent-module__fileName--uNFoM {
    min-width: 200px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.FilesComponent-module__emptyBox--YN8Ix {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100px;
}

.FilesComponent-module__emptyBox--YN8Ix>p {
    font-size: 16px;
    color: #6f879c7a;
    font-weight: 500;
}`, "",{"version":3,"sources":["webpack://./src/features/task/ui/FilesComponent.module.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,uBAAuB;IACvB,gBAAgB;IAChB,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,QAAQ;IACR,eAAe;IACf,YAAY;IACZ,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,qBAAqB;IACrB,qDAAqD;IACrD,mBAAmB;IACnB,UAAU;IACV,8BAA8B;IAC9B,+BAA+B;AACnC;;AAEA;IACI,sBAAsB;IACtB,oDAAoD;AACxD;;AAEA;IACI,aAAa;IACb,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;;AAE3B;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;AAC3B;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,aAAa;AACjB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,gBAAgB;AACpB","sourcesContent":[".filesBox {\r\n    display: flex;\r\n    flex-direction: column;\r\n    gap: 20px;\r\n    align-items: flex-start;\r\n    margin-top: 20px;\r\n    max-height: 600px;\r\n    overflow-y: auto;\r\n}\r\n\r\n.fileItem {\r\n    display: flex;\r\n    flex-direction: row;\r\n    align-items: center;\r\n    gap: 5px;\r\n    cursor: pointer;\r\n    padding: 8px;\r\n    color: #0054E6;\r\n    font-size: 14px;\r\n    font-weight: 500;\r\n    text-decoration: none;\r\n    box-shadow: 0px 0px 28px -15px rgba(34, 60, 80, 0.51);\r\n    border-radius: 14px;\r\n    width: 90%;\r\n    justify-content: space-between;\r\n    transition: transform 0.3s ease;\r\n}\r\n\r\n.fileItem:hover {\r\n    transform: scale(1.02);\r\n    box-shadow: 0px 5px 30px -10px rgba(34, 60, 80, 0.7);\r\n}\r\n\r\n.leftBox {\r\n    display: flex;\r\n    gap: 16px;\r\n    align-items: center;\r\n}\r\n\r\n.fileIcon {\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n\r\n}\r\n\r\n.fileName {\r\n    min-width: 200px;\r\n    white-space: nowrap;\r\n    overflow: hidden;\r\n    text-overflow: ellipsis;\r\n}\r\n\r\n.emptyBox {\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n    height: 100px;\r\n}\r\n\r\n.emptyBox>p {\r\n    font-size: 16px;\r\n    color: #6f879c7a;\r\n    font-weight: 500;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"filesBox": `FilesComponent-module__filesBox--Hslzj`,
	"fileItem": `FilesComponent-module__fileItem--EhXXF`,
	"leftBox": `FilesComponent-module__leftBox--ddfn4`,
	"fileIcon": `FilesComponent-module__fileIcon--VyZgB`,
	"fileName": `FilesComponent-module__fileName--uNFoM`,
	"emptyBox": `FilesComponent-module__emptyBox--YN8Ix`
};
export default ___CSS_LOADER_EXPORT___;
